<template>
  <div>
    <!-- Base Info -->
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>{{ $t('기본정보') }}</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
        <div class="col-span-6 flex items-center ">
          <div class="label-text mr-4">{{ $t('회사명') }}</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_1 }}</p>
          <ml-input
            :readonly="true"
            v-else
            v-model="form.inputA_1"
            class="w-full flex-1"
          />
        </div>
        <div class="col-start-1 col-span-6 flex items-center">
          <div class="label-text mr-4">{{ $t('소속') }}</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_0 }}</p>
          <ml-input
            v-else
            class="w-full flex-1"
            v-model="form.inputA_0"
            :readonly="true"
          />
        </div>
        <div class="col-start-1 col-span-6 flex items-center">
          <div class="label-text mr-4">{{ $t('부서') }}</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_4 }}</p>
          <ml-input
            :readonly="true"
            v-else
            v-model="form.inputA_4"
            class="w-full flex-1"
          />
        </div>
        <div class="col-start-1 col-span-6 flex items-center">
          <div class="label-text mr-4">{{ $t('작업장명') }}</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_2 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_2"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-12 flex my-3">
          <div class="label-text mr-4">{{ $t('점검구분') }}</div>
          <div class="ml-group-checkBox flex flex-wrap w-full flex-1">
            <p v-if="isPrint" class="w-full flex-1">
              {{ getNameCategory(form.category[0]) }}
            </p>
            <vs-checkbox
              v-else
              v-for="checkBox in optionCheckBox"
              :key="checkBox.id"
              v-model="form.category"
              :vs-value="checkBox.id"
              color="#1e0d61"
              @change="uniqueCheck"
              class="mr-4 mb-2"
            >
              {{ checkBox.label }}
            </vs-checkbox>
          </div>
        </div>
        <div class="col-start-1 col-span-6 flex items-center">
          <div class="label-text mr-4">{{ $t('점검일자') }}</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_3 }}</p>
          <date-selector
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_3"
            class="w-full flex-1"
          ></date-selector>
        </div>
        <div class="col-start-1 col-span-4 flex items-center ">
          <div class="label-text mr-4">{{ $t('점검부서') }}</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_5 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_5"
            class="w-full flex-1"
          />
        </div>
        <div class=" col-span-4 flex items-center ">
          <div class="label-text mr-4">{{ $t('직위') }}</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_6 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_6"
            class="w-full flex-1"
          />
        </div>
        <div class=" col-span-4 flex items-center ">
          <div class="label-text mr-4">{{ $t('점검자') }}</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_7 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_7"
            class="w-full flex-1"
          />
        </div>
        <div class="col-start-1 col-span-4 flex items-center ">
          <div class="label-text mr-4">{{ $t('수검부서') }}</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_8 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_8"
            class="w-full flex-1"
          />
        </div>
        <div class=" col-span-4 flex items-center ">
          <div class="label-text mr-4">{{ $t('직위') }}</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_9 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_9"
            class="w-full flex-1"
          />
        </div>
        <div class=" col-span-4 flex items-center ">
          <div class="label-text mr-4">{{ $t('수검자') }}</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputA_10 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            v-model="form.inputA_10"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>

    <!-- Request -->

    <table-safeguard
      :dataRequest="dataTable"
      :list="form.list"
      @update-list-check="updateListCheck"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-safeguard>

    <!-- Detail -->
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
          ><h5><i class="dot"></i>{{ $t('기타 특이사항 및 요구사항') }}</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
        <div class="col-span-12 flex items-center ">
          <div class="label-text mr-4 self-start pt-2">{{ $t('아차사고') }}</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_1 }}</p>
          <ml-textarea
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_1"
            rows="5"
            placeholder="“아차사고 사례” 최소 1건 작성(서술형 작성)"
          />
        </div>
        <div class="col-span-12 flex items-center">
          <div class="label-text mr-4 self-start pt-2">{{ $t('종합의견/특이사항') }}</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_2 }}</p>
          <ml-textarea
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_2"
            rows="5"
            placeholder="내용"
          />
        </div>
        <div class="col-span-12 flex items-center">
          <div class="label-text mr-4 self-start pt-2">{{ $t('개선요구사항') }}</div>
          <p v-if="isPrint" class="w-full flex-1">{{ form.inputB_3 }}</p>
          <ml-textarea
            :readonly="board.readonly"
            v-else
            v-model="form.inputB_3"
            rows="5"
            placeholder="내용"
          />
        </div>
      </div>
    </div>
    <file-upload-module
      :readonly="board.readonly"
      v-if="!isPrint"
      v-model="form.fileList"
      class="w-full mt-component-form"
    />
  </div>
</template>
<script>
import DateSelector from "@/components/selector/DateSelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import TableSafeguard from "@/components/TableSafeguard.vue";
export default {
  components: {
    DateSelector,
    DisasterClassSelector,
    FileUploadModule,
    TableSafeguard
  },
  props: {
    board: Object,
    value: Object,
    isPrint: {
      type: Boolean
    }
  },
  computed: {
    optionCheckBox() {
      return [
        {
          id: 1,
          label: "청사",
          dataTable: [
            {
              title: "인적",
              data: [
                {
                  text: "작업자의 불안전한 작업 여부",
                  index: 1
                },
                {
                  text: "고위험 작업 다인 1조 작업 여부",
                  index: 2
                },
                {
                  text: "근로자 안전 작업을 위한 교육 시행 여부",
                  index: 3
                }
              ]
            },
            {
              title: "물적",
              data: [
                {
                  text: "보유하고 있는 개인보호구 등의 관리 상태",
                  index: 4
                },
                {
                  text: "소화 시설‧기구의 여부 및 관리 상태",
                  index: 5
                },
                {
                  text: "화학물질 관리 상태(MSDS 등)",
                  index: 6
                },
                {
                  text:
                    "경고표지 및 비상구 표지 여부(중량물, 고온 경고 표지, 밀폐공간, 기계·기구, 고압가스 시설 등)",
                  index: 7
                },
                {
                  text: "기계·기구 설비의 방호 상태",
                  index: 8
                },
                {
                  text:
                    "AED, 구급약 등 응급조치 물품‧기구 비치 여부(주기적 점검, 작동 여부, 구급상자 점검·보충 등)",
                  index: 9
                }
              ]
            },
            {
              title: "물질 및 환경적",
              data: [
                {
                  text: "청사, 시설물의 파손, 훼손 여부",
                  index: 10
                },
                {
                  text:
                    "청사 사무실 및 통로 정리정돈 상태(넘어짐, 미끄러짐, 충돌 등 위험 여부)",
                  index: 11
                },
                {
                  text: "비상구 확보 여부",
                  index: 12
                }
              ]
            },
            {
              title: "관리적",
              data: [
                {
                  text:
                    "청사 시설물 안전에 대한 자체점검 실시 여부(체크리스트 등)",
                  index: 13
                }
              ]
            }
          ]
        },
        {
          id: 2,
          label: "식당 안전보건",
          dataTable: [
            {
              title: "안전관리 상태",
              data: [
                {
                  text: "바닥의 물·기름·물때 등으로 인해 미끄러질 위험 여부",
                  index: 1
                },
                {
                  text: "통로 확보 및 통행로에 물품 적재·방치 여부",
                  index: 2
                },
                {
                  text: "장애물(문턱·배관·패인곳 등)로 인해 넘어질 위험 여부",
                  index: 3
                },
                {
                  text: "조리장·계단·통로에 적정한 조명 설치 여부",
                  index: 4
                },
                {
                  text: "계단에 난간 설치, 답단 끝에 미끄럼방지 조치 여부",
                  index: 5
                },
                {
                  text: "미끄럼방지용 안전장화·작업화 등 착용 여부",
                  index: 6
                },
                {
                  text: "재료운반대차 및 배식차에 끼일 위험 여부",
                  index: 7
                },
                {
                  text: "사용중량, 경고표지 부착 여부",
                  index: 8
                },
                {
                  text: "전기 기계·기구에 감전예방용 접지 상태 여부",
                  index: 9
                },
                {
                  text: "누전차단기 설치 및 월1회 이상 동작 점검 여부",
                  index: 10
                },
                {
                  text: "전선의 노후화 또는 피복손상, 심하게 구부러짐 여부",
                  index: 11
                },
                {
                  text: "식당 후드청소 등의 작업 시 추락할 위험 여부",
                  index: 12
                },
                {
                  text: "기타 각종 위험요인으로부터 근로자 보호 조치 여부",
                  index: 13
                }
              ]
            },
            {
              title: "보건관리 상태",
              data: [
                {
                  text:
                    "고온 스팀 사용장소 “고온경고”, “화상주의”표지 게시 여부",
                  index: 14
                },
                {
                  text: "뜨거운 용기 취급 시 방열장갑 또는 보조집게 사용 여부",
                  index: 15
                },
                {
                  text:
                    "조리실 등 고온다습하고 환기가 불충분한 장소에 적정한 환기, 통풍, 냉방시설 설치 및 관리 여부",
                  index: 16
                },
                {
                  text: "물질안전보건자료(MSDS)의 게시(비치) 및 교육 여부",
                  index: 17
                },
                {
                  text: "취급용기 및 포장에 MSDS 경고표지 부착 여부",
                  index: 18
                },
                {
                  text:
                    "세제, 청소제 등 화학물질 취급시 고무장갑 등 적정 보호장구 착용 여부",
                  index: 19
                },
                {
                  text: "근골격계부담작업 유해요인조사 실시여부",
                  index: 20
                },
                {
                  text:
                    "근골격계질환 예방을 위해 인력작업 보조설비 및 편의설비 등 작업환경 개선여부",
                  index: 21
                },
                {
                  text:
                    "근골격계부담 종사자에 대한 유해성 주지(교육 등) 적정성",
                  index: 22
                },
                {
                  text: "중량물 안내포스터 부착 유무(5kg 이상를 중량물로 취급)",
                  index: 23
                },
                {
                  text: "작업 전·후 스트레칭 실시 및 적정 휴식시간 배분 여부",
                  index: 24
                },
                {
                  text:
                    "운반작업 시 적정한 양 운반, 2인 1조 작업 또는 이동식 대차 등 운반보조도구 사용 여부",
                  index: 25
                }
              ]
            }
          ]
        },
        {
          id: 3,
          label: "대국민 시설물",
          dataTable: [
            {
              title: "인적",
              data: [
                {
                  text: "작업자의 불안전한 작업 여부",
                  index: 1
                },
                {
                  text: "고위험 작업 다인 1조 작업 여부",
                  index: 2
                },
                {
                  text: "근로자 안전 작업을 위한 교육 시행 여부",
                  index: 3
                }
              ]
            },
            {
              title: "물적",
              data: [
                {
                  text: "보유하고 있는 개인보호구 등의 관리 상태",
                  index: 4
                },
                {
                  text: "소화 시설‧기구의 여부 및 관리 상태",
                  index: 5
                },
                {
                  text: "화학물질 관리 상태(MSDS 등)",
                  index: 6
                },
                {
                  text:
                    "경고표지 및 비상구 표지 여부(중량물, 고온 경고 표지, 밀폐공간, 기계·기구, 고압가스 시설 등)",
                  index: 7
                },
                {
                  text: "기계·기구 설비의 방호 상태",
                  index: 8
                },
                {
                  text:
                    "AED, 구급약 등 응급조치 물품‧기구 비치 여부(주기적 점검, 작동 여부, 구급상자 점검·보충 등)",
                  index: 9
                }
              ]
            },
            {
              title: "물질 및 환경적",
              data: [
                {
                  text: "시설물의 파손, 훼손 여부",
                  index: 10
                },
                {
                  text:
                    "시설물 및 통로 정리정돈 상태(넘어짐, 미끄러짐, 충돌 등 위험 여부)",
                  index: 11
                },
                {
                  text:
                    "고압가스 충전실 용기보관장소 경계표시, 통풍시설 확보 및 자체점검 실시 여부",
                  index: 12
                },
                {
                  text: "비상구 확보 여부",
                  index: 13
                }
              ]
            },
            {
              title: "관리적",
              data: [
                {
                  text:
                    "대국민 시설물 안전에 대한 자체점검 실시 여부(체크리스트 등)",
                  index: 14
                }
              ]
            }
          ]
        },
        {
          id: 4,
          label: "사육시설",
          dataTable: [
            {
              title: "인적",
              data: [
                {
                  text: "작업자의 불안전한 작업 여부",
                  index: 1
                },
                {
                  text: "고위험 작업 다인 1조 작업 여부",
                  index: 2
                },
                {
                  text: "근로자 안전 작업을 위한 교육 시행 여부",
                  index: 3
                }
              ]
            },
            {
              title: "물적",
              data: [
                {
                  text: "보유하고 있는 개인보호구 등의 관리 상태",
                  index: 4
                },
                {
                  text: "소화 시설‧기구의 여부 및 관리 상태",
                  index: 5
                },
                {
                  text: "화학물질 관리 상태(MSDS 등)",
                  index: 6
                },
                {
                  text:
                    "경고표지 및 비상구 표지 여부(중량물, 고온 경고 표지, 밀폐공간, 기계·기구, 고압가스 시설 등)",
                  index: 7
                },
                {
                  text: "기계·기구 설비의 방호 상태",
                  index: 8
                },
                {
                  text: "작업장의 적절한 조도 확보 상태",
                  index: 9
                },
                {
                  text:
                    "AED, 구급약 등 응급조치 물품‧기구 비치 여부(주기적 점검, 작동 여부, 구급상자 점검·보충 등)",
                  index: 10
                }
              ]
            },
            {
              title: "물질 및 환경적",
              data: [
                {
                  text: "시설물의 파손, 훼손 여부",
                  index: 11
                },
                {
                  text:
                    "통로 및 작업장 정리정돈 상태(넘어짐, 미끄러짐, 충돌 등 위험 여부)",
                  index: 12
                },
                {
                  text: "감전 위험요인에 대한 제거 및 방호 여부",
                  index: 13
                },
                {
                  text:
                    "소음, 진동, 호흡기 등 위험요인에 대한 제거 및 방호 여부",
                  index: 14
                },
                {
                  text: "가연물, 화기 취급주의 등 화재폭발 위험 제거 여부",
                  index: 15
                },
                {
                  text: " 비상구 확보 여부",
                  index: 16
                }
              ]
            },
            {
              title: "관리적",
              data: [
                {
                  text:
                    "사육 시설물 안전에 대한 자체점검 실시 여부(체크리스트 등)",
                  index: 17
                }
              ]
            }
          ]
        },
        {
          id: 5,
          label: "잠수작업 현장",
          dataTable: [
            {
              title: "작업자 상태/숙지사항",
              data: [
                {
                  text: "인원 구성(잠수작업자, 선상작업자)",
                  index: 1
                },
                {
                  text: "자격 조건(잠수사 자격 확인)",
                  index: 2
                },
                {
                  text:
                    " 잠수작업 계획 이행 여부(작업시간, 재잠수시간, 잠수 입·출수 계획 등)",
                  index: 3
                },
                {
                  text: "작업자, 선장 건강상태(음주, 혈압 등)",
                  index: 4
                },
                {
                  text: "작업시간(휴식 시간 포함) 적정성",
                  index: 5
                },
                {
                  text: "작업일지 등 작성 여부",
                  index: 6
                }
              ]
            },
            {
              title: "필수장비 상태 점검 /착용 여부",
              data: [
                {
                  text: "잠수작업자 : 잠수복, 호흡기 등 착용 여부",
                  index: 7
                },
                {
                  text: " 선상작업자 : 구명조끼, 안전화 등 착용 여부",
                  index: 8
                }
              ]
            },
            {
              title: "안전사고 예방",
              data: [
                {
                  text: "안전교육 실시 여부(실시 시간 및 장소 비고란에 기재)",
                  index: 9
                },
                {
                  text: "선박 내 폭발물, 가연성물질 적정 장소 보관 여부",
                  index: 10
                },
                {
                  text: "선박 내 소방설비(소화기 등) 보관 여부",
                  index: 11
                },
                {
                  text: "선박 내 구급 및 구조용품 비치 여부",
                  index: 12
                },
                {
                  text: "선박 내 위험요소 점검, 어선특별검사 유무 확인",
                  index: 13
                },
                {
                  text:
                    "해상 날씨 상태(혹한, 혹서기 또는 폭우와 같은 위험요소 발생 시 감독관에게 현장 상황 보고)",
                  index: 14
                },
                {
                  text: "위험성평가 실시 결과 및 위험성 감소대책 이행 여부",
                  index: 15
                }
              ]
            },
            {
              title: "작업환경",
              data: [
                {
                  text: "기타 위험요소 여부",
                  index: 16
                }
              ]
            }
          ]
        },
        {
          id: 6,
          label: "해상작업 현장",
          dataTable: [
            {
              title: "작업자 상태/숙지사항",
              data: [
                {
                  text: "인원 구성",
                  index: 1
                },
                {
                  text: "자격 조건",
                  index: 2
                },
                {
                  text: "작업자, 선장 건강상태(음주, 혈압 등)",
                  index: 3
                },
                {
                  text: "작업시간(휴식 시간 포함) 적정성",
                  index: 4
                },
                {
                  text: "작업일지 등 작성 여부",
                  index: 5
                }
              ]
            },
            {
              title: "필수장비 상태 점검 /착용 여부",
              data: [
                {
                  text: "선상작업자 : 구명조끼, 안전화 등 착용 여부",
                  index: 6
                }
              ]
            },
            {
              title: "안전사고 예방",
              data: [
                {
                  text: "안전교육 실시 여부(실시 시간 및 장소 비고란에 기재)",
                  index: 7
                },
                {
                  text: "선박 내 폭발물, 가연성물질 적정 장소 보관 여부",
                  index: 8
                },
                {
                  text: "선박 내 소방설비(소화기 등) 보관 여부",
                  index: 9
                },
                {
                  text: "선박 내 구급 및 구조용품 비치 여부",
                  index: 10
                },
                {
                  text: "선박 내 위험요소 점검, 어선특별검사 유무 확인",
                  index: 11
                },
                {
                  text:
                    "해상 날씨 상태(혹한, 혹서기 또는 폭우와 같은 위험요소 발생 시 감독관에게 현장 상황 보고)",
                  index: 12
                },
                {
                  text: "위험성평가 실시 결과 및 위험성 감소대책 이행 여부",
                  index: 13
                }
              ]
            },
            {
              title: "작업환경",
              data: [
                {
                  text: "기타 위험요소 여부",
                  index: 14
                }
              ]
            }
          ]
        },
        {
          id: 7,
          label: "육상작업 현장",
          dataTable: [
            {
              title: "작업자 상태/숙지사항",
              data: [
                {
                  text: "인원 구성(책임자, 작업자 등)",
                  index: 1
                },
                {
                  text: "작업자 건강상태(음주, 혈압 등)",
                  index: 2
                },
                {
                  text: "작업시간(휴식 시간 포함) 적정성",
                  index: 3
                },
                {
                  text: "자격 조건(착수 시 제출한 서류 대조 확인)",
                  index: 4
                },
                {
                  text: "작업 계획(과업 숙지 등) 숙지 여부",
                  index: 5
                },
                {
                  text: "작업일지 등 작성 여부",
                  index: 6
                }
              ]
            },
            {
              title: "필수장비 상태 점검 /착용 여부",
              data: [
                {
                  text: "필수장비 착용 여부(안전모, 안전화 등)",
                  index: 7
                },
                {
                  text: "장비 작동상태 여부(건설 장비, 투입장비 노후 등)",
                  index: 8
                }
              ]
            },
            {
              title: "안전사고 예방",
              data: [
                {
                  text:
                    "작업 관련 서류 보관 여부(건설서류, 공사작업일지, 안전일지 등)",
                  index: 9
                },
                {
                  text: "중요·보안문서 관리 상태 점검",
                  index: 10
                },
                {
                  text:
                    "안전교육 실시 여부(안전판 비치 및 안전교육 등)\n ※ 안전교육 실시 시간 및 장소 비고란 기재",
                  index: 11
                },
                {
                  text: "작업장 내 소방설비(소화기 등) 보관 여부",
                  index: 12
                },
                {
                  text: "작업장 내 구급 및 구조용품 비치 여부",
                  index: 13
                },
                {
                  text: "자재 등 물품 적재(추락물) 및 관리상태 점검",
                  index: 14
                },
                {
                  text: "위험성평가 실시 결과 및 위험성 감소대책 이행 여부",
                  index: 15
                }
              ]
            },
            {
              title: "작업환경",
              data: [
                {
                  text: "재해예방기술지도 이행 여부",
                  index: 16
                },
                {
                  text: "기타 위험요소 여부",
                  index: 17
                }
              ]
            }
          ]
        },
        {
          id: 8,
          label: "갯벌 작업 현장",
          dataTable: [
            {
              title: "작업자 상태/숙지사항",
              data: [
                {
                  text: "인원 구성(책임자, 작업자 등)",
                  index: 1
                },
                {
                  text: "작업자 건강상태(음주, 혈압 등)",
                  index: 2
                },
                {
                  text: "작업시간(휴식 시간 포함) 적정성",
                  index: 3
                },
                {
                  text: "작업 계획(과업 숙지 등) 숙지 여부",
                  index: 4
                },
                {
                  text: "작업 위치(진입·이탈로 등) 숙지 여부",
                  index: 5
                },
                {
                  text: "작업 당일 물때표 등 숙지 여부",
                  index: 6
                }
              ]
            },
            {
              title: "필수장비 상태 점검 /착용 여부",
              data: [
                {
                  text:
                    "안전장비 착용 점검(원색의 의복, 장갑·장화 등 보호구, 소형튜브 등)",
                  index: 7
                },
                {
                  text: "장비 상태 점검(뻘배, GPS 등) ",
                  index: 8
                }
              ]
            },
            {
              title: "안전사고 예방",
              data: [
                {
                  text: "안전교육 실시 여부",
                  index: 9
                },
                {
                  text: "준비체조 수행 여부",
                  index: 10
                },
                {
                  text:
                    "비상상황 대비물품 구비 여부(구조 요청용 호루라기, 휴대전화 등)",
                  index: 11
                },
                {
                  text: "구급 및 구조용품 비치 여부",
                  index: 12
                },
                {
                  text: "위험성평가 실시 결과 및 위험성 감소대책 이행 여부",
                  index: 13
                }
              ]
            },
            {
              title: "작업환경",
              data: [
                {
                  text:
                    "해상 날씨 상태 여부(혹한, 혹서기 또는 폭우와 같은 위험요소 발생 시 감독관에게 현장상황 보고)",
                  index: 14
                },
                {
                  text: "기타 위험요소 여부",
                  index: 15
                }
              ]
            }
          ]
        }
      ];
    }
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inputA_1 =
          this.value && this.value.inputA_1
            ? this.value.inputA_1
            : this.board.projectTitle;
        this.form.inputA_4 =
          this.value && this.value.inputA_4
            ? this.value.inputA_4
            : this.board.writer.com_name;
        this.form.inputA_3 =
          this.value && this.value.inputA_3
            ? this.value.inputA_3
            : this.board.writer.name;
        this.form.inputA_0 =
          this.value && this.value.inputA_0
            ? this.value.inputA_0
            : this.board.writer.department;
      }
    },
    value(value) {
      const keys = Object.keys(this.form);
      for (const key of keys) {
        this.form[key] = value[key];
      }

      // Load table and image
      let objCheckBoxSelected = this.optionCheckBox.find(
        n => n.label === this.getNameCategory(this.form.category[0])
      );
      if (objCheckBoxSelected) {
        this.dataTable = objCheckBoxSelected.dataTable;
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = value.inputA_1;
        value.summary = {
          "점검표": [{'작업장 안전점검표': 1}],
          "점검구분": [
            { [this.form.categoryLabel]: 1 }
          ]
        }
        this.$emit("input", value);
      }
    }
  },
  name: "Write",
  data() {
    return {
      form: {
        fileList: [],
        list: [],
        category: [],
        categoryLabel: "",
        inputA_0: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",
        inputA_9: "",
        inputA_10: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: ""
      },
      dataTable: []
    };
  },
  methods: {
    updateListCheck(indexRows, text) {
      this.form.list[indexRows].is_checked = text;
    },

    uniqueCheck(curentData) {
      this.form.category = [curentData[curentData.length - 1]];
      if (this.form.category[0]) {
        this.form.categoryLabel = this.getNameCategory(this.form.category[0]);
        this.dataTable = this.optionCheckBox.filter(
          x => x.id === this.form.category[0]
        )[0].dataTable;
        let temp = [];
        this.dataTable.forEach(element => {
          element.data.forEach(el => {
            temp.push({
              text: el.text,
              is_checked: "",
              note: el.note
            });
          });
        });
        this.form.list = temp;
      } else {
        this.dataTable = [];
        this.form.categoryLabel = "";
      }
    },

    getNameCategory(index) {
      if (index) {
        const result = this.optionCheckBox.find(x => x.id === index);
        return result.label;
      }
    }
  }
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin-left: 15px;
  margin: 0;
}

/* Table */
.row-header {
  background-color: $bg;
  text-align: center;
  height: 100px;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border: $border;
  border-left: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: none;
}

/* row data */
.row-content {
  border-bottom: $border;
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}
.row-content__body-item {
  .item-content {
    padding: 15px;
    border-left: $border;
  }
  .item-box {
    border-left: $border;
    border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-area {
    padding: 5px;
  }
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
</style>
